import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["prefixCls", "className", "dashed"];
import classNames from "classnames";
import { Divider } from "rc-menu9";
import * as React from "react";
import { ConfigContext } from "../ConfigProvider";
import { jsx as _jsx } from "react/jsx-runtime";
var MenuDivider = function MenuDivider(_ref) {
  var customizePrefixCls = _ref.prefixCls,
    className = _ref.className,
    dashed = _ref.dashed,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls;
  var prefixCls = getPrefixCls("menu", customizePrefixCls);
  var classString = classNames(_defineProperty({}, "".concat(prefixCls, "-item-divider-dashed"), !!dashed), className);
  return /*#__PURE__*/_jsx(Divider, _objectSpread({
    className: classString
  }, restProps));
};
export default MenuDivider;